<template>
  <span
    @click="$emit('input', !value)"
    class="arrow transition"
    v-bind="$attrs"
    v-bind:class="{ rotate: !value }"
  >
    <svg class="arrow" :class="{dark}" viewBox="0 0 24 20">
      <path d="M19.78,11.78L18.36,13.19L12,6.83L5.64,13.19L4.22,11.78L12,4L19.78,11.78Z" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'toggle-arrow',

  props: {
    value: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss">
.arrow {
  margin-top: auto;
  margin-bottom: auto;
  height: 20px;  // If I dont add this the arrow rotation is weird
  fill: $color_black;
  &.dark {
    fill: white;
  }
}
</style>
